// MIDAS V3 — Attach-column context (MODEL-PICKER Feature 2, spec §6)
//
// Identifies which attached column a chat subtree belongs to. Default null =
// the PRIMARY chat. AttachedChatColumnV3 wraps its subtree in the provider;
// consumers:
//   • ChatBotMessageV3 — follow-up chips + regenerate + feedback target the
//     COLUMN's thread (not the global activeThreadId), and artifact opens
//     dispatch setArtifactSourceThread(ctx.threadId) so the pane knows which
//     column stays visible.
//   • CiteV3 — same source tagging on citation-chip clicks.
//
// Also home to the cross-tree "focus attached column" event: the history
// rail (outside the column strip's React tree) asks the strip to scroll to a
// column + flash its 700ms accent ring when the user clicks an attached
// thread's row (design: clicking an attached row ≠ navigation). Same
// CustomEvent loose-coupling pattern as MIDAS_V3_FOCUS_COMPOSER_EVENT.

import { createContext, useContext } from "react";

export interface AttachColumnContextValue {
  threadId: string;
  machineId: string | null;
}

export const AttachColumnContext =
  createContext<AttachColumnContextValue | null>(null);

/** null = primary chat. */
export const useAttachColumn = (): AttachColumnContextValue | null =>
  useContext(AttachColumnContext);

/** CustomEvent name — detail: { threadId: string }. Dispatched by the rail,
 *  consumed by MultiChatRowV3 (scroll to column + 700ms flash ring). */
export const MIDAS_V3_FOCUS_ATTACHED_COLUMN_EVENT =
  "midas-v3-focus-attached-column";

export const dispatchFocusAttachedColumn = (threadId: string): void => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(MIDAS_V3_FOCUS_ATTACHED_COLUMN_EVENT, {
      detail: { threadId },
    })
  );
};
